import script from "./BirthAsk.vue?vue&type=script&setup=true&lang=js"
export * from "./BirthAsk.vue?vue&type=script&setup=true&lang=js"

import "./BirthAsk.vue?vue&type=style&index=0&id=56821c18&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56821c18"]])

export default __exports__